import React from 'react';

export default function Steak() {
	return (
		<g>
			<path fill="#FCDAC9" d="M111.36121,412.26398c-21.60423-6.65387-33.21066,8.11615-53.48628,4.79791
				c-14.46355-2.36707-19.65802-11.46265-20.05922-21.48553c-0.11988-2.995,0.12861-17.94119,1.00339-20.94699
				c1.3478-4.63113,95.14935,0.39929,96.655,9.6474c0.60736,3.73053,0.73875,10.84598,0.73842,17.31342
				c-0.0002,3.57187-0.89211,6.43344-3.02869,8.27155C126.84409,415.31583,116.60106,413.87778,111.36121,412.26398z" />
			<path fill="#F96E6E" d="M64.70508,400.58896c-1.90918,0-3.7627-0.15137-5.66797-0.46387
				c-12.00488-1.96387-16.66895-8.47119-18.4668-13.58447c-2.92383-8.3125-0.26367-19.04102,6.61914-26.69727
				c8.43652-9.38623,20.69531-14.76953,33.63281-14.76953c8.49609,0,16.83008,2.31543,24.10254,6.69531
				c20.86719,12.56982,29.04102,25.79883,29.73145,33.9873c0.28027,3.31982-0.60156,5.96045-2.55078,7.63672
				c-3.35645,2.88818-8.21875,3.49463-11.70703,3.49463c-3.17676,0-6.73535-0.5127-9.51953-1.37012
				c-3.7793-1.16357-7.42969-1.72949-11.15918-1.72949c-6.47559,0-12.18945,1.74414-17.71582,3.43164
				c-5.42285,1.65625-11.03125,3.36816-17.2959,3.36914C64.70703,400.58896,64.70605,400.58896,64.70508,400.58896z" />
			<path fill="#FCF1ED" d="M80.82568,344.07388v2.43857v2.56143h0.00049c7.76636,0,15.3855,2.11679,22.03394,6.12158
				c19.59937,11.80606,27.23096,24.02319,27.81079,30.89801c0.11694,1.38586,0.00806,3.25128-1.17334,4.26779
				c-2.34741,2.01941-6.1355,2.44327-8.89966,2.44327c-3.89819,0-7.40967-0.81485-8.73853-1.16519
				c-3.37109-0.88885-6.71606-1.32104-10.22559-1.32129c-0.00122,0-0.00171,0-0.00293,0c-6.80835,0-12.96777,1.65918-18.92334,3.26364
				c-5.82935,1.5704-11.33545,3.05371-17.36646,3.05371c-1.92749,0-3.77832-0.14954-5.65771-0.45712
				c-7.97119-1.30457-13.27539-5.0961-15.3396-10.96472c-2.45264-6.97403-0.11377-16.09479,5.81982-22.69586
				c7.6792-8.54294,18.85425-13.44302,30.65942-13.44382L80.82568,344.07388 M80.82275,344.07385
				c-12.82715,0.00089-25.44971,5.16925-34.37769,15.10129c-12.36377,13.75436-12.16821,37.91168,12.43066,41.93747
				c2.2312,0.36517,4.38013,0.5228,6.46533,0.5228c13.19922,0,23.82056-6.31821,36.29224-6.31735
				c2.86743,0.00018,5.83496,0.33435,8.95142,1.15607c2.41846,0.63766,6.12671,1.33041,10.01318,1.33041
				c4.34985,0,8.92334-0.86804,12.1604-3.65283c7.46289-6.42044,1.60059-25.81946-27.31836-43.23923
				C97.80664,346.31436,89.27124,344.07327,80.82275,344.07385L80.82275,344.07385z" />
			<path fill="#FCF1ED" d="M91.88825,371.09552c-1.80331-1.04956-3.52293-1.94815-5.33472-2.82779
				c-1.82592-0.88248-3.71305-1.64325-5.59232-2.45798c-2.54025-1.10132,2.65073-2.78131,5.1755-3.86929l0.12392-0.05319
				c0.75134-0.32938,1.31895-1.05048,1.38834-1.97174c0.08915-1.18347-0.81598-2.19513-1.97217-2.46301
				c-3.15079-0.72995-6.47181-0.62982-9.67706,0.07523c-3.27209,0.73239-6.44224,2.11026-9.24186,4.0506
				c-1.41521,0.94791-2.71927,2.06494-3.90768,3.28702c-0.60479,0.60126-1.14661,1.26306-1.68639,1.91971
				c-0.54087,0.69818-1.11825,1.48865-1.55053,2.28809c-0.91195,1.5994-1.55176,3.31088-1.89623,5.0813
				c-0.33253,1.76715-0.40148,3.61249,0.03461,5.40842c0.1879,0.7612,0.76173,1.43842,1.62519,1.68741
				c1.05913,0.30545,2.18368-0.25449,2.72134-1.21677l0.09021-0.16147c1.27881-2.28998,2.73475-4.26614,4.33658-5.90408
				c0.41274-0.4137,0.78083-0.76385,1.24026-1.15231c0.00439-0.00394,0.00877-0.0079,0.01315-0.01184
				c0.85564-0.76953,1.9997-1.13086,3.14875-1.06793c0.8153,0.04468,1.63589,0.10971,2.46245,0.2095
				c1.81262,0.20767,3.64329,0.48346,5.46976,0.85886c1.82755,0.36649,3.65727,0.79889,5.47396,1.30054
				c1.80013,0.49704,3.65687,1.08148,5.34055,1.68896l0.10614,0.03882c1.28634,0.46518,2.78196-0.14713,3.31393-1.52859
				C93.55461,373.10767,92.99619,371.74039,91.88825,371.09552z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Steak.js